export * from './legal-constants';
export * from './legal-links';
export * from './legal-wording';
export * from './legal.module';
